import { Box, Button, Grid, Typography } from "@material-ui/core";
import { isNil } from "@roc/feature-utils";
import { StandardDialog } from "@roc/ui";
import { formatCurrency } from "@roc/ui/utils";

const Item = ({title, value}) => {
  return(
    <Grid item container xs={4} direction="column">
      <Typography style={{fontWeight: 'bold'}}>
        {title}
      </Typography>
      <Typography style={{marginLeft: '4px'}}>
        {value}
      </Typography>
    </Grid>
  )
}

const ViewDetailsModal = ({open, onClose, title, quote}) => {

  const getMoneyField = (value) => {
    return !isNil(value) ? formatCurrency(value) : '-'
  }

  const extraDetails = quote?.quoteAdditionalInformation ? JSON.parse(quote?.quoteAdditionalInformation) : null;

  const information = [{title: "Payment Type", value: quote?.paymentType ? quote?.paymentType : '-'}, {title: "General Liability Aggregate Limit", value: getMoneyField(extraDetails?.generalLiabilityAggregateLimit)}, {title: "Damage To Premises Rented To You Limit", value: getMoneyField(extraDetails?.damageToPremisesLimit)}, {title: "All Other Perils Deductible", value: getMoneyField(extraDetails?.allOtherPerilsDeductible)}, {title: "Valuation", value: extraDetails?.valuation ? extraDetails?.valuation : '-'}, {title: "Tax", value: getMoneyField(extraDetails?.tax)}, {title: "Medical Expense Limit", value: getMoneyField(extraDetails?.medicalExpenseLimit)}, {title: "Personal And Advertising Injury Limit", value: getMoneyField(extraDetails?.personalAndAdvertisingInjuryLimit)}, {title: "Building Limit of Insurance", value: getMoneyField(extraDetails?.buildingLimitOfInsurance)}, {title: "Liability Deductible", value: getMoneyField(extraDetails?.liabilityDeductible)},{title: "Coinsurance", value: getMoneyField(extraDetails?.coinsurance)},{title: "Gross Premium", value: getMoneyField(quote?.insurancePremium)},{title: "General Liability Occurrence Limit", value: getMoneyField(extraDetails?.generalLiabiltyOccurenceLimit)},{title: "Flood Limit", value: getMoneyField(extraDetails?.floodLimit)},{title: "Windstorm Or Hail Deductible", value: getMoneyField(extraDetails?.windstormDeductible)},{title: "Causes Of Loss", value: extraDetails?.causeOfLoss ? extraDetails?.causeOfLoss : '-'},{title: "Cost Of Policy", value: getMoneyField(extraDetails?.costOfPolicy)},{title: "Docusign Completed", value: extraDetails?.docusignCompleted ? "Yes" : "No"}, {title: "Quote Owner", value: extraDetails?.quoteOwner ? extraDetails?.quoteOwner : '-'}]

  return(
    <StandardDialog
      title={title}
      open={open}
      handleClose={onClose}
      maxWidth="md"
      dialogActions={
        <Box flex="1" display="flex" justifyContent="flex-end">
          <Button style={{ marginRight: 16 }}
            variant="contained"
            color="primary"
            onClick={onClose}
          >
            Close
          </Button>
        </Box>
      }
      dialogContent={
        <Grid container xs={12} spacing={2} direction="row">
          {information.map((item) => {
            return(
              <Item title={item.title} value={item.value}/>
            )
          })}
        </Grid>
      }
    />
  )
}

export default ViewDetailsModal;